// extracted by mini-css-extract-plugin
export default {"loader":"index_loader__6Y1Cb","dot":"index_dot__hA7Mr","dotter":"index_dotter__jQeWW","glow":"index_glow__6uC3j"};